'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { MenuActionId } from '../enums'

export const BASE_WORKSPACE_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    label: 'Settings',
    icon: Icon.SettingsRegular,
    id: MenuActionId.WORKSPACE_SETTINGS,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    label: 'Invite people',
    icon: Icon.PeopleAddRegular,
    id: MenuActionId.INVITE_PEOPLE,
    size: 'xs',
  },
  {
    id: 'sep-1',
    type: 'separator',
  },
]
